// extracted by mini-css-extract-plugin
export default {"content":"WhiteListPage_content__VTnam","header":"WhiteListPage_header__bzUa1","switch":"WhiteListPage_switch__RZyLH"};